// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as VehicleDetailsCmp$PorterinFeature from "./VehicleDetailsCmp.mjs";
import * as VehicleModalLayoutModuleScss from "../styles/VehicleModalLayout.module.scss";

var styles = VehicleModalLayoutModuleScss;

function VehicleModalLayoutCmp(Props) {
  var children = Props.children;
  var modal = Props.modal;
  var vehicle = Props.vehicle;
  var modal_content = Props.modal_content;
  return React.createElement("div", {
              className: styles["estimate-layout-container"]
            }, vehicle !== undefined ? React.createElement(VehicleDetailsCmp$PorterinFeature.make, {
                    vehicle: vehicle,
                    title: modal_content.title
                  }) : React.createElement("section", {
                    className: styles["title-container"]
                  }, React.createElement("p", {
                        className: styles["title-mobile"]
                      }, modal_content.title)), React.createElement("section", {
                  className: styles["form-container"]
                }, children), React.createElement("button", {
                  className: styles["close-modal-button"],
                  onClick: (function (param) {
                      Curry._1(modal.close_modal, undefined);
                    })
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: modal_content.icon.path,
                      height: 24.0,
                      width: 24.0,
                      quality: 100.0,
                      alt: modal_content.icon.alt_text
                    })));
}

var make = VehicleModalLayoutCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
